(function () {
  'use strict';

  var cities = [
    // Australian cities (~60%)
    'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide',
    'Canberra', 'Hobart', 'Darwin', 'Gold Coast', 'Newcastle',
    'Wollongong', 'Geelong', 'Townsville', 'Cairns', 'Toowoomba',
    'Ballarat', 'Bendigo', 'Launceston', 'Mackay', 'Rockhampton',
    'Bunbury', 'Albury', 'Hervey Bay', 'Wagga Wagga', 'Mildura',
    'Shepparton', 'Gladstone', 'Port Macquarie', 'Tamworth',
    'Orange', 'Dubbo', 'Bathurst', 'Byron Bay', 'Broome',
    'Alice Springs', 'Broken Hill', 'Lavington', 'Wodonga',
    // International (~40%)
    'London', 'New York', 'Los Angeles', 'Toronto', 'Vancouver',
    'Auckland', 'Wellington', 'Christchurch', 'Singapore',
    'Hong Kong', 'Tokyo', 'Dubai', 'Amsterdam', 'Berlin',
    'Paris', 'Barcelona', 'Rome', 'Copenhagen', 'Stockholm',
    'Oslo', 'Zurich', 'Vienna', 'Cape Town', 'Johannesburg',
    'Mumbai', 'Chicago', 'Seattle', 'Portland',
    'Atlanta', 'Miami', 'Denver', 'Phoenix', 'Houston'
  ];

  var SocialProofToast = {
    products: [],
    currentIndex: -1,
    cycleTimer: null,
    hideTimer: null,
    isVisible: false,

    settings: {
      minInterval: 12000,
      maxInterval: 22000,
      displayDuration: 5500,
      initialDelay: 8000,
      prefixText: 'Someone in',
      suffixText: 'bought',
      preventRepeat: true
    },

    init: function () {
      // Merge Liquid-rendered settings
      if (window.spSettings) {
        var s = window.spSettings;
        if (s.minInterval)     this.settings.minInterval     = s.minInterval;
        if (s.maxInterval)     this.settings.maxInterval     = s.maxInterval;
        if (s.displayDuration) this.settings.displayDuration = s.displayDuration;
        if (s.initialDelay)    this.settings.initialDelay    = s.initialDelay;
        if (s.prefixText)      this.settings.prefixText      = s.prefixText;
        if (s.suffixText)      this.settings.suffixText      = s.suffixText;
      }

      // Skip cart / checkout / thank you pages
      var path = window.location.pathname;
      if (path.indexOf('/cart')      === 0 ||
          path.indexOf('/checkout')  === 0 ||
          path.indexOf('/thank_you') !== -1) {
        return;
      }

      // Only keep products that have an image
      this.products = (window.spProducts || []).filter(function (p) {
        return p && p.image;
      });

      if (this.products.length === 0) return;

      console.log('[Social Proof Toast] ' + this.products.length + ' products loaded.');

      this.bindEvents();

      var self = this;
      setTimeout(function () {
        self.showNext();
        self.startCycle();
      }, self.settings.initialDelay);
    },

    getRandomProduct: function () {
      if (this.products.length === 1) return this.products[0];
      var index;
      var tries = 0;
      do {
        index = Math.floor(Math.random() * this.products.length);
        tries++;
      } while (index === this.currentIndex && this.settings.preventRepeat && tries < 10);
      this.currentIndex = index;
      return this.products[index];
    },

    getRandomLocation: function () {
      return cities[Math.floor(Math.random() * cities.length)];
    },

    getRandomTimeAgo: function () {
      var rand = Math.random();
      if (rand < 0.20) {
        return 'Just now';
      } else if (rand < 0.40) {
        var mins = Math.floor(Math.random() * 58) + 2;
        return mins + ' minutes ago';
      } else if (rand < 0.75) {
        var hours = Math.floor(Math.random() * 23) + 1;
        return hours === 1 ? '1 hour ago' : hours + ' hours ago';
      } else {
        var days = Math.floor(Math.random() * 3) + 1;
        return days === 1 ? '1 day ago' : days + ' days ago';
      }
    },

    getRandomInterval: function () {
      return Math.floor(
        Math.random() * (this.settings.maxInterval - this.settings.minInterval)
        + this.settings.minInterval
      );
    },

    populate: function (product) {
      var img       = document.getElementById('sp-toast-img');
      var locationEl = document.getElementById('sp-toast-location');
      var productEl  = document.getElementById('sp-toast-product');
      var timeEl     = document.getElementById('sp-toast-time');
      var toast      = document.getElementById('sp-toast');

      img.src = product.image;
      img.alt = product.title;

      locationEl.textContent = this.settings.prefixText + ' ' + this.getRandomLocation() + ' ' + this.settings.suffixText;
      productEl.textContent  = product.title;
      timeEl.textContent     = this.getRandomTimeAgo();

      var url = product.url;
      toast.onclick = function () { window.location.href = url; };
    },

    show: function () {
      var toast = document.getElementById('sp-toast');
      if (!toast || this.isVisible) return;

      toast.style.display = 'flex';
      toast.classList.remove('sp-exiting');
      void toast.offsetWidth; // force reflow so animation triggers
      toast.classList.add('sp-entering');
      this.isVisible = true;

      var self = this;
      this.hideTimer = setTimeout(function () { self.hide(); }, self.settings.displayDuration);
    },

    hide: function () {
      var toast = document.getElementById('sp-toast');
      if (!toast || !this.isVisible) return;

      clearTimeout(this.hideTimer);
      toast.classList.remove('sp-entering');
      toast.classList.add('sp-exiting');
      this.isVisible = false;

      setTimeout(function () {
        toast.style.display = 'none';
        toast.classList.remove('sp-exiting');
      }, 400);
    },

    showNext: function () {
      var product = this.getRandomProduct();
      if (!product) return;
      this.populate(product);
      this.show();
    },

    startCycle: function () {
      var self = this;
      function scheduleNext() {
        var interval = self.getRandomInterval();
        self.cycleTimer = setTimeout(function () {
          self.showNext();
          scheduleNext();
        }, interval);
      }
      scheduleNext();
    },

    bindEvents: function () {
      var self = this;

      var closeBtn = document.getElementById('sp-toast-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          self.hide();
        });
      }

      var toast = document.getElementById('sp-toast');
      if (toast) {
        toast.addEventListener('mouseenter', function () {
          clearTimeout(self.hideTimer);
        });
        toast.addEventListener('mouseleave', function () {
          if (self.isVisible) {
            self.hideTimer = setTimeout(function () { self.hide(); }, 2000);
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isVisible) self.hide();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SocialProofToast.init(); });
  } else {
    SocialProofToast.init();
  }
})();
